// extracted by mini-css-extract-plugin
export default {"canvasWrapper":"Canvas_canvasWrapper__ACqOy","canvas":"Canvas_canvas__x2lKd","canvasColumn":"Canvas_canvasColumn__W83aF","floatingEditor":"Canvas_floatingEditor__Wh5CH"};